import { CONSENT_STATUS } from './constants';
import { acceptService, showSecondLayer } from './adapter';
import {
  getConsentSnapshot,
  getServerConsentSnapshot,
  initConsentStore,
  refreshConsentStore,
  resetConsentStore,
  subscribeToConsent,
} from './store';

export {
  CMP_TIMEOUT_MS,
  CONSENT_CATEGORIES,
  CONSENT_SERVICES,
  CONSENT_STATUS,
  DENIED_SNAPSHOT,
} from './constants';

export {
  getConsentSnapshot,
  getServerConsentSnapshot,
  initConsentStore,
  resetConsentStore,
  subscribeToConsent,
};

// The only question most call sites need answered. Anything other than an
// explicit grant is a refusal - an unknown or unavailable CMP must never
// unblock a third party.
export const hasConsent = (serviceId) => {
  if (!serviceId) {
    return false;
  }

  return getConsentSnapshot().services[serviceId] === true;
};

export const hasCategoryConsent = (categorySlug) => {
  if (!categorySlug) {
    return false;
  }

  return getConsentSnapshot().categories[categorySlug] === true;
};

// False means the consent dialog cannot be opened at all, so the UI should
// offer something else rather than a button that does nothing.
export const isConsentUiAvailable = () =>
  getConsentSnapshot().status !== CONSENT_STATUS.UNAVAILABLE;

export const openConsentSettings = () => showSecondLayer();

// Grants a single service, for the "accept and play this video" flow. Resolves
// to false when the CMP is not there, so the caller can keep the placeholder.
export const requestServiceConsent = (serviceId) =>
  acceptService(serviceId).then((isAccepted) => {
    // A programmatic grant is not a CMP UI interaction, so none of the events
    // the store listens to is guaranteed to follow it.
    if (isAccepted) {
      refreshConsentStore();
    }

    return isAccepted;
  });

export const initConsent = () => initConsentStore();
